import axiosInstance from "../lib/axiosInstance";

class guestloginModel {

    constructor() {
        this.base_url = "/guest_users"
    }
    async list(query = []) {
       
        return (await axiosInstance.get(`${this.base_url}?${new URLSearchParams(query)}`)).data;
    }
   

}

export default new guestloginModel();